import cx from 'clsx';
import React, { SyntheticEvent } from 'react';

import { SearchIcon } from '@/components/icons';
import { MEDIUM_BREAKPOINT } from '@/components/modular-grid/constants';
import { useWindowSize } from '@/hooks/useWindowSize';
import { formatMessage } from '@/utils';
import { formatNumberOfSearchGames } from '@/utils/formatNumberOfSearchGames';

import styles from './SearchBar.module.scss';

interface SearchBarPropsTypes {
  visible?: boolean;
  placeholder?: string;
  search_modal_link?: string;
  numberOfAllSearchGames?: number;
  onSearchBarClick?: (args: { path: string; itemTitle: string }) => void;
}

const SearchBar: React.FC<SearchBarPropsTypes> = ({
  onSearchBarClick,
  placeholder,
  search_modal_link,
  numberOfAllSearchGames,
  visible = false,
}) => {
  const { width } = useWindowSize();

  const size = width <= MEDIUM_BREAKPOINT.max ? 'small' : 'wide';

  if (!visible || !search_modal_link || size === 'wide') return null;

  const formatedNumberOfAllSearchGames = formatNumberOfSearchGames(
    numberOfAllSearchGames
  );
  const placeholderText = formatedNumberOfAllSearchGames
    ? formatMessage(placeholder, {
        numberOfAllSearchGames: formatedNumberOfAllSearchGames,
      })
    : '';
  const routeLink = search_modal_link;

  const handleClick = (event: SyntheticEvent, path: string, title: string) => {
    event.preventDefault();
    onSearchBarClick &&
      onSearchBarClick({
        path,
        itemTitle: title,
      });
  };

  return (
    <div className={cx(styles.searchBar)}>
      <a
        className={styles.link}
        href={routeLink}
        onClick={e => handleClick(e, routeLink, placeholderText)}
      >
        <div data-testid="search-bar-icon" className={styles.searchIconWrapper}>
          <SearchIcon />
        </div>
        {placeholderText}
      </a>
    </div>
  );
};

export default SearchBar;
